import { createService } from "./createService"
import { SERVICE_INSTANCES } from "./serviceInstances"

const service = createService(SERVICE_INSTANCES.onboarding)
// Interceptor-free instance for calls made from unauthenticated pages.
const publicService = createService("publicNewArchAxiosInstance")

export const ONBOARDING_INSTANCE = service.instanceKey

export const ONBOARDING_ENDPOINTS = {
  VIEW_REGISTER: "/account/view/register",
  CREATE_ACCOUNT: "/account/create",
  CREATE_PASSWORD: "/account/createpassword",
  SET_PASSWORD: "/account/setpassword",
  SAVE_REFERRAL: "/account/save_referral",
  CHECK_EMAIL: "/admin/people/checkemail",
  NOTIFY_SLACK: "/notifications/slack",
  GET_COUNTRIES: "/commonutils/getcountries",
  GET_SETUP_INFO: "/account/getcompanysetupinfo",
  EMPLOYEE_SETUP: "/employee_onboarding/view/setup",
} as const

export const onboardingService = {
  instanceKey: service.instanceKey,

  viewRegister: (code: string) =>
    service.get(ONBOARDING_ENDPOINTS.VIEW_REGISTER, { code }),

  createAccount: (body: Record<string, any>) =>
    service.post(ONBOARDING_ENDPOINTS.CREATE_ACCOUNT, body),

  createPassword: (body: Record<string, any>) =>
    service.post(ONBOARDING_ENDPOINTS.CREATE_PASSWORD, body),

  setPassword: (body: Record<string, any>) =>
    service.post(ONBOARDING_ENDPOINTS.SET_PASSWORD, body),

  // Called from the public employee-onboarding page.
  saveReferral: (body: Record<string, any>) =>
    publicService.post(ONBOARDING_ENDPOINTS.SAVE_REFERRAL, body),

  // Called from the public employer-onboarding page. New arch answers 200
  // "Available" or 400 with the reason when the email is already in use.
  checkEmail: (email: string, personId: number | string = -1) =>
    publicService.get(ONBOARDING_ENDPOINTS.CHECK_EMAIL, {
      email,
      person_id: personId,
    }),

  // Fire-and-forget CX ping from the public business-registration page.
  // Returns a bare 200 (no envelope) on the new backend.
  notifySlack: (body: {
    text: string
    username?: string
    iconEmoji?: string
  }) => publicService.post(ONBOARDING_ENDPOINTS.NOTIFY_SLACK, body),

  getCountries: () => service.get(ONBOARDING_ENDPOINTS.GET_COUNTRIES),

  getSetupInfo: (
    companyId?: number | undefined,
    organisationId?: number | undefined
  ) =>
    service.get(ONBOARDING_ENDPOINTS.GET_SETUP_INFO, {
      company_id: companyId,
      organisation_id: organisationId,
    }),

  getEmployeeSetup: () => service.get(ONBOARDING_ENDPOINTS.EMPLOYEE_SETUP),
}
